export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--H.d5bec473.png";